import { Injectable } from '@angular/core';
import {HttpService} from '@api/http/http.service';
import {DefaultResponse, IDefaultListResponse, IDefaultResponse} from '@api/models/default-response/response';
import {IClub} from '@api/models/club/club';
import {IClubRegistration} from '@api/models/club/club-registration';
import {USERS_ROUTE_NEW} from '@api/http/http-routes';

@Injectable({
  providedIn: 'root'
})
export class ClubHttpService {

  constructor(private http: HttpService) { }

  public async getClub(clubId: string): Promise<IClub> {
    return this.http.get(['clubs', clubId]);
  }

  public async postClubRegistration(data: IClubRegistration): Promise<DefaultResponse> {
    return this.http.post<DefaultResponse>(
      [USERS_ROUTE_NEW, 'club', 'registration'], data
    ).toPromise();
  }

  public async postSearchClubs(query: string): Promise<Partial<IClub>[]> {
    const response = await this.http.post<IDefaultListResponse<IClub>>(
      ['search', 'clubs'], { search_string: query }
    ).toPromise();
    return response.data;
  }

}
